// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import * as bootstrap from 'bootstrap'

// document.querySelectorAll("#navbar a, #navbar .nav-item").forEach(function(el) {
//     el.addEventListener("click", function() {
//         const offcanvasEl = document.querySelector("#navbar");
//         const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl);
//         if (bsOffcanvas) {
//             bsOffcanvas.hide();
//         }
//     });
// });


document.querySelectorAll("#navbar a, #navbar .nav-item").forEach(function(anchor) {
    anchor.addEventListener("click", function(event) {
        const href = anchor.getAttribute("href");

        if (href && href.startsWith("#")) {
            event.preventDefault(); // verhindert das Standardverhalten

            const offcanvasEl = document.querySelector("#navbar");
            const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl);

            if (bsOffcanvas) {
                bsOffcanvas.hide();

                // Warte, bis das Offcanvas-Element vollständig geschlossen ist
                offcanvasEl.addEventListener("hidden.bs.offcanvas", function handler() {
                    offcanvasEl.removeEventListener("hidden.bs.offcanvas", handler); // nur einmal ausführen

                    const target = document.querySelector(href);
                    if (target) {
                        target.scrollIntoView({ behavior: "smooth" });
                    }
                });
            } else {
                // Falls kein Offcanvas offen ist
                const target = document.querySelector(href);
                if (target) {
                    target.scrollIntoView({ behavior: "smooth" });
                }
            }
        }
    });
});